import create from 'zustand';
import produce from 'immer';

import { getSearchItem } from 'lib/api/glossary';
import { IGlossaryState, IGlossaryAction, IGlossaryData } from '../types';

const initialState: IGlossaryState = {
  glossaries: [],
  glossary: null,
  searchData: [],
};

type GlossaryStore = IGlossaryState & IGlossaryAction;

const useGlossaryStore = create<GlossaryStore>((set) => ({
  ...initialState,
  setGlossaries: (glossaries: IGlossaryData[]) => {
    set(
      produce((state: IGlossaryState) => {
        state.glossaries = glossaries;
      }),
    );
  },
  setGlossary: (glossary: IGlossaryData) => {
    set(
      produce((state: IGlossaryState) => {
        state.glossary = glossary;
      }),
    );
  },
  setGlossarySearch: (searchData: IGlossaryData[]) => {
    set(
      produce((state: IGlossaryState) => {
        state.searchData = searchData;
      }),
    );
  }
}));

export default useGlossaryStore;
